<template>
  <RecoveryPass></RecoveryPass>
</template>

<script>
// @ is an alias to /src
import RecoveryPass from "@/components/RecoveryPass.vue";
export default {
  name: "RecoveryPassView",
  components: { RecoveryPass }
};
</script>
